// src/store/index.js
//
// Vue3-Migration: Vuex 3 -> Pinia.
//
// Der frühere Vuex-Store wurde 1:1 als EIN Pinia-Store (`useAppStore`) nachgebildet:
// identischer State, identische Getter-Namen, jede frühere Vuex-Mutation und -Action als
// gleichnamige Pinia-Action. Die Komponenten sowie `src/plugins/axios.js` greifen direkt
// über `useAppStore()` bzw. die Pinia-Options-API-Helper (`mapState`/`mapActions` aus
// 'pinia') auf diesen Store zu. Der frühere `$store`-Kompat-Shim und der `vuex`-Alias
// (Phase 2c) sind entfernt.

import { defineStore } from 'pinia'

function initialState() {
  return {
    breadCrumb: [],
    count: 1,
    accessToken: null,
    cancelTokens: [],
    MS_ACCESSTOKEN: null,
    companies: [],
    loadingRouteChange: false,
    verkauf: false,
    favType: 'private',
    prevPg: '',
    currPgState: {
      model: 0,
      supplier: 0
    },
    modelCurrState: {
      list: [],
      title: '',
      sort: 'AZ'
    },
    supplierCurrState: {
      list: [],
      title: '',
      sort: 'AZ'
    },
    favorite: {
      seller: {
        model: false,
        supplier: false
      },
      buyer: {
        model: false,
        supplier: false
      }
    },
    query: {
      goodsGroup: '',
      changedSince: '',
      isExclusive: false,
      modelStatus: false,
      hasSPCZFile: false
    },
    models: {
      page: 1,
      query: '',
      options: [],
      paginator: {},
      loading: false,
      selected: null
    },
    suppliers: {
      page: 1,
      options: [],
      paginator: {},
      loading: false,
      selected: null
    },
    goodsGroups: {
      page: 1,
      query: '',
      options: [],
      paginator: {},
      loading: false,
      selected: null
    },
    priceLists: {
      page: 1,
      options: [],
      paginator: {},
      loading: false,
      selected: []
    },
    verkaufTab: 0,
    einkaufTab: 0,
    listingType: 0,
    tableView: 0,
    systemTab: 0,
    error: null
  }
}

export const useAppStore = defineStore('app', {
  state: initialState,
  getters: {
    // Namen 1:1 aus dem alten Vuex-Store übernommen.
    getMsAccessToken: (state) => state.MS_ACCESSTOKEN,
    getLoadingRoute: (state) => state.loadingRouteChange,
    getAccessToken: (state) => state.accessToken,
    getBreadCrumb: (state) => state.breadCrumb,
    getCompanies: (state) => state.companies,
    getQuery: (state) => state.query,
    getModels: (state) => state.models,
    getSuppliers: (state) => state.suppliers,
    getGoodsgroups: (state) => state.goodsGroups,
    getPriceList: (state) => state.priceLists,
    getCount: (state) => state.count,
    getVerkauf: (state) => state.verkauf,
    getVerkaufTab: (state) => state.verkaufTab,
    getEinkaufTab: (state) => state.einkaufTab,
    getListingType: (state) => state.listingType,
    getFavorite: (state) => state.favorite,
    getFavoriteType: (state) => state.favType,
    getSystemTab: (state) => state.systemTab,
    getTableView: (state) => state.tableView,
    getError: (state) => state.error
  },
  actions: {
    // --- Vuex-Mutationen als gleichnamige Actions (Signatur: (payload)) ---
    SET_ERROR(error) {
      this.error = error
    },
    SET_MS_ACCESSTOKEN(par) {
      this.MS_ACCESSTOKEN = par
    },
    SET_LOADING_ROUTE(par) {
      this.loadingRouteChange = par
    },
    SET_BREADCRUMB(par) {
      this.breadCrumb = par
    },
    SET_ACCESSTOKEN(par) {
      this.accessToken = par
    },
    SET_COMPANIES(par) {
      this.companies = par
    },
    ADD_CANCEL_TOKEN(token) {
      this.cancelTokens.push(token)
    },
    CLEAR_CANCEL_TOKENS() {
      this.cancelTokens = []
    },
    SET_QUERY(par) {
      this.query = par
    },
    SET_MODELS(par) {
      this.models = par
    },
    SET_SUPPLIERS(par) {
      this.suppliers = par
    },
    SET_GOODSGROPUS(par) {
      this.goodsGroups = par
    },
    SET_PRICELIST(par) {
      this.priceLists = par
    },
    SET_VERKAUF(par) {
      this.verkauf = par
    },
    SET_VERKAUF_TAB(par) {
      this.verkaufTab = par
    },
    SET_EINKAUF_TAB(par) {
      this.einkaufTab = par
    },
    SET_LISTING_TYPE(par) {
      this.listingType = par
    },
    SET_TABLE_VIEW(par) {
      this.tableView = par
    },
    SET_SYSTEM_TAB(par) {
      this.systemTab = par
    },
    SET_FAVORITE(par) {
      this.favorite[par.route][par.type] = par.val
    },
    SET_FAVORITE_TYPE(par) {
      this.favType = par
    },
    SET_CURRENT_PAGE_STATE(par) {
      this.currPgState[par.type] = par.pos
    },
    SET_SUPPLIER_CURRENT_STATE(par) {
      this.supplierCurrState.list = par[0]
      this.supplierCurrState.title = par[1]
      this.supplierCurrState.sort = par[2]
    },
    SET_MODEL_CURRENT_STATE(par) {
      this.modelCurrState.list = par[0]
      this.modelCurrState.title = par[1]
      this.modelCurrState.sort = par[2]
    },
    // --- Vuex-Actions ---
    CANCEL_PENDING_REQUESTS() {
      this.cancelTokens.forEach((request) => {
        request.cancel()
      })
      // Reset the cancelTokens store
      this.CLEAR_CANCEL_TOKENS()
    },
    incrementCount() {
      this.count++
    }
  }
})
